import { render, staticRenderFns } from "./vcModalDialog.vue?vue&type=template&id=8b890e3a&"
import script from "./vcModalDialog.vue?vue&type=script&lang=js&"
export * from "./vcModalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports